export default function scrollIntoContact() {
    const buttonClick = document.querySelectorAll('#go-to-contact, #more_info');
    const SectionShow = document.querySelector('.accordion-contact, .more_info');
    const AccordionShow = document.querySelector('.accordion-contact .accordion-item .accordion-collapse');
    const buttonAccordion = document.querySelector('.accordion-contact .accordion-item .accordion-header .accordion-button');
    const pageID = document.querySelectorAll('.page-id-884, .page-id-1531, .page-id-1584, .page-id-884');

    if (pageID) {
        buttonClick.forEach(btn => {
            btn.addEventListener('click', () => {
                SectionShow.scrollIntoView({behavior: "smooth", block: "start"});
                AccordionShow.classList.add('show');
                buttonAccordion.classList.remove('collapsed');
            });
        });
    }
}